import React from 'react';
import SectionIncomingConsignment from '../SectionIncomingConsignment';

const RnMInwardConsignment = () => (
  <SectionIncomingConsignment
    sectionName="R & M"
    sectionDisplayName="R & M"
    backRoute="/sections/rnm"
  />
);

export default RnMInwardConsignment;
